import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalVariant,
  TextInput,
  Title,
} from '@patternfly/react-core';
import {useEffect, useState} from 'react';
import {AlertVariant, useUI} from 'src/contexts/UIContext';
import {useCreateTag} from 'src/hooks/UseTags';
import {isNullOrUndefined} from 'src/libs/utils';

export default function AddTagModal(props: AddTagModalProps) {
  const [value, setValue] = useState('');
  const {addAlert} = useUI();
  const {createTag, successCreateTag, errorCreateTag} = useCreateTag(
    props.org,
    props.repo,
  );

  useEffect(() => {
    if (successCreateTag) {
      addAlert({
        variant: AlertVariant.Success,
        title: `Successfully created tag ${value}`,
      });
      setValue('');
      props.loadTags();
      props.setIsOpen(false);
      if (!isNullOrUndefined(props.onComplete)) {
        props.onComplete();
      }
    }
  }, [successCreateTag]);

  useEffect(() => {
    if (errorCreateTag) {
      addAlert({
        variant: AlertVariant.Failure,
        title: `Could not create tag ${value}`,
      });
      setValue('');
      props.setIsOpen(false);
      if (!isNullOrUndefined(props.onComplete)) {
        props.onComplete();
      }
    }
  }, [errorCreateTag]);

  return (
    <>
      <Modal
        id="add-tag-modal"
        aria-label="Add tag modal"
        isOpen={props.isOpen}
        onClose={() => props.setIsOpen(false)}
        variant={ModalVariant.small}
      >
        <Title headingLevel="h2">
          Add tag to manifest {props.manifest.substring(0, 19)}
        </Title>
        <ModalBody>
          <TextInput
            value={value}
            type="text"
            onChange={(_event, value) => setValue(value)}
            aria-label="new tag name"
            placeholder="New tag name"
          />
        </ModalBody>
        <ModalFooter>
          <Button
            key="cancel"
            variant="primary"
            onClick={() => props.setIsOpen(false)}
          >
            Cancel
          </Button>
          <Button
            key="modal-action-button"
            variant="primary"
            onClick={() => {
              createTag({tag: value, manifest: props.manifest});
            }}
          >
            Create tag
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

interface AddTagModalProps {
  org: string;
  repo: string;
  isOpen: boolean;
  manifest: string;
  setIsOpen: (open: boolean) => void;
  loadTags: () => void;
  onComplete?: () => void;
}
